<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            {{roleid == 2 ? "Department of Agri Product Sale and Marketing/ Market Plan" : "DPP Branch/ Market Plan"}}
          </h2>
        </div>
      </div>
      <h3 class="title">
            ການກວດກາມາດຕະຖານອິນຊີ (Form + Report)
      </h3>
      <b-tabs v-model="activeTab" v-if="roleid == 2 || roleid == 3">
        
        <b-tab-item label="ລາຍການຟາມ">
          <div class="columns scrollme">
            <div class="column">
              <b-field label="ລາຍການຟາມ">
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="40%">
                        ຊື່ຟາມ
                      </th>
                      <th class="has-text-right " width="30%">
                        ຈຳນວນຫົວຂໍ້
                      </th>
                      <th class="has-text-centered " width="30%">
                        ຈັດການ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in farmlist" :key="data.ID">
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.FARMNAME }}
                      </td>
                      <td>
                        --/--
                      </td>
                      

                      <td class="has-text-centered">
                        <b-field group>
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"
                              @click="
                                openTabForm(data)
                              "
                              >ປະກອບຟອມ
                            </b-button>
                          </b-field>

                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-info"
                              size="is-small"
                              @click="
                                openTabReport(data)
                              "
                              >ເບິ່ງຟອມທີ່ປ້ອນ
                            </b-button>
                          </b-field>
                        </b-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>
        <b-tab-item label="ຟອມຂໍ້ມູນ">
          <b-field v-if="selectedFarmName === null">
            <button class="button is-info" @click="goToFarmtlist">
              ເລືອກຟາມກ່ອນ
            </button>
          </b-field>
          <b-field v-else>
            <div class="columns scrollme">
              <div class="column">
                <b-field :label="selectedFarmName">
                  <div class="container">                  
                    <b-tabs v-model="activeSubTab">
                        <b-tab-item  v-for="formsection in formsections" :key="formsection.SECTIONID" :label="formsection.SECTIONTITLE"> 
                        <b-field >
                            <div  style="width: 30%">
                              <h1 class="titleh3">{{ formsection.SECTIONNAME }}</h1>
                            </div>
                            <div  style="width: 30%">
                            </div>
                            <div  style="width: 30%">
                                <b-button style="width: 200px;"
                                class="btn-group-margin"
                                type="is-primary"
                                @click="saveOAICS()"
                                >ບັນທືກ, ຕໍ່ໄປ >>
                              </b-button >
                            </div>
                            
                        </b-field>
                      
                        <b-field v-for="(formdetail, index) in formdetails" :key="formdetail.ITEMID">
                          <div v-if="formsection.SECTIONID == formdetail.SECTIONID" style="width: 25%; padding-left: 10px">
                              {{index +1}} . {{formdetail.ITEMNAME}}
                          </div>

                          <div v-if="formsection.SECTIONID == formdetail.SECTIONID" style="width: 35%; padding-left: 10px" >
                                <b-input v-model.trim="formdetail.ITEMVALUE" v-if="formdetail.TYPE==1"> </b-input>

                                <b-field class="group" v-if="formdetail.TYPE==2">
                                  <b-field>
                                    <b-datepicker placeholder="ເລືອກວັນທີ"
                                      :date-formatter="dateFormatter"
                                      v-model="formdetail.ITEMVALUE"
                                    >
                                    </b-datepicker>
                                  </b-field>
                                </b-field>
                                
                          </div>
                          <div v-if="formsection.SECTIONID == formdetail.SECTIONID" style="width: 40%; padding-left: 10px">
                            <b-input maxlength="200" rows="2" type="textarea"></b-input>
                          </div>

                          <!-- <div v-if="formsection.SECTIONID == formdetail.SECTIONID" style="width: 25%"></div> -->
                            
                        </b-field>
                        <b-field >
                              <div  style="width: 30%">
                              </div>
                              <div  style="width: 30%">
                              </div>
                              <div  style="width: 30%;">
                                  <b-button style="width: 200px;"
                                  class="btn-group-margin"
                                  type="is-primary"
                                  @click="saveOAICS()"
                                  >ບັນທືກ, ຕໍ່ໄປ >>
                                </b-button >
                              </div>
                          </b-field>
                        </b-tab-item>
                    </b-tabs>
                  </div>
                </b-field>
              </div>
            </div>  
          </b-field>
        </b-tab-item>

        <b-tab-item label="ລາຍການແບບຟອມທີ່ບັນທືກແລ້ວ">
           <b-field v-if="selectedFarmName === null">
            <button class="button is-info" @click="goToFarmtlist">
              ເລືອກຟາມກ່ອນ
            </button>
          </b-field>
          <b-field v-else>
            <div class="columns scrollme">
              <div class="column">
                <b-field label="ລາຍການ">
                
                </b-field>
              </div>
            </div>
          </b-field>
          
        </b-tab-item>

        

        
      </b-tabs>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
// import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
  // components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
      userName: null,
      roleid: null,
      activeTab: 0,
      activeSubTab: 0,

      farmlist: [],
      formdetails: [],
      formsections:[],
      farmername: null,

      selectedFarmID: null,
      selectedFarmName: null,
      

    };
  },
  methods: {
    openTabForm(data){
      this.activeTab = 1;
      this.selectedFarmID =  data.ID;
      this.selectedFarmName = data.FARMNAME;
    },
    openTabReport(data){
      this.activeTab = 2;
      this.selectedFarmID =  data.ID;
      this.selectedFarmName = data.FARMNAME;
    },
    goToFarmtlist(){
      this.activeTab = 0;
    },
    getOAICSRecordForm() {
      RestAPI.getOAICSRecordForm()
        .then(res => {
          // console.log("res: " + JSON.stringify(res))
          this.formdetails = res.data.formdetail;
          this.formsections = res.data.formsection;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    saveOAICS(){
      var params = {
          formdetails: this.formdetails,
          farmid: this.selectedFarmID,
          username: this.username
        };
        console.log("params: " + JSON.stringify(params));
        RestAPI.saveOAICS(params)
          .then(() => {
            // this.$swal("ສ້າງຕະຫຼາດ ສຳເລັດ!", "", "success");

           this.activeSubTab = this.activeSubTab + 1;
            // console.log(res);
          })
          .catch(error => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      
    },

    getFarmList(){
      // console.log("ok: " , this.userProvinceID)
      RestAPI.getDppOAFarmList(this.userProvinceID)// ແລ້ວອັບເດດເປັນ branchid ແລະ ໄປຊອກໃນ ຶ branchprovinces
        .then(res => {
          this.farmlist = res.data;
          // console.log("getDppFarmList: " + JSON.stringify(this.farmerList))
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },
    print() {
      window.print();
    }
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.userProvinceID = this.user.BRANCHPROVNICEID ? this.user.BRANCHPROVNICEID : 'all';
    this.getOAICSRecordForm();
    this.getFarmList();
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.table-div{
  /* margin-bottom: 100px; */
}
.titleh3{
  font-size: 20px;
  font-weight: bold;
  padding-bottom: 15px;
}
</style>
